import Layout from "../components/layout/Layout";
import Breadcrumb from "../components/layout/Breadcrumb";
import Section from "../components/layout/Section";
import DienstCard from "../components/diensten/DienstCard";
import Title from "../components/layout/Title";
import Sectors from "../components/shared/Sectors";
import Waarom from "../components/diensten/Waarom";
import Head from "next/head";
import React from "react";
import {faChalkboardUser} from "@fortawesome/free-solid-svg-icons/faChalkboardUser";
import {faPuzzlePiece} from "@fortawesome/free-solid-svg-icons/faPuzzlePiece";
import {faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons/faMagnifyingGlass";
import {faCompass} from "@fortawesome/free-solid-svg-icons/faCompass";


const PageDiensten = () => {
    return (
        <>
            <Head>
                <link rel="manifest" href="/manifest.webmanifest"/>
                <link rel="apple-touch-icon" href="/assets/imgs/app/apple-touch-icon.png"/>
                <link
                    rel="apple-touch-icon"
                    sizes="48x48"
                    href="/assets/imgs/app/apple-touch-icon-48x48.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="57x57"
                    href="/assets/imgs/app/apple-touch-icon-57x57.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="72x72"
                    href="/assets/imgs/app/apple-touch-icon-72x72.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="76x76"
                    href="/assets/imgs/app/apple-touch-icon-76x76.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="114x114"
                    href="/assets/imgs/app/apple-touch-icon-114x114.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="120x120"
                    href="/assets/imgs/app/apple-touch-icon-120x120.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="144x144"
                    href="/assets/imgs/app/apple-touch-icon-144x144.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="152x152"
                    href="/assets/imgs/app/apple-touch-icon-152x152.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="180x180"
                    href="/assets/imgs/app/apple-touch-icon-180x180.png"
                />
                <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5"/>
                <meta charSet="utf-8"/>
                <meta name="msapplication-TileColor" content="#ffffff"/>
                <meta name="msapplication-TileImage" content="/assets/imgs/ms-icon-144x144.png"/>
                <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
                <meta name="viewport" content="width=device-width, initial-scale=1"/>
                <meta name="author" content="Cohesian"/>
                <meta name="theme-color" content="#ffffff"/>
                <meta name="description" content="Maakindustrie – Automotive – ICT – Farmaceutica & cosmetica"/>
                <meta name="keywords"
                      content="Engineering, Consultancy/consulting, Entrepreneurship, Entrepreneur, Ondernemer, Ondernemerschap, Technische profielen, Ingenieur, Innovatie, Fun, Connectie, Connection, Excellence, Excellentie, Ingenieursbureau, Partner, Persoonlijke ontwikkeling, Projectsourcing, Recruitment, Rekrutering, Training, Begeleiding, advies, Vacature, Jobs, Werk, Functie, Fun factor, Koffie, Netwerken, Maakindustrie, Automotive, Farmaceutica, Cosmetica"/>
                <meta property="og:title" content="Cohesian Engineering"/>
                <meta property="og:description"
                      content="Visit our website for updates and information about Cohesian Engineering."/>
                <meta property="og:url" content="https://www.cohesian.be/"/>
                <title>Cohesian | Diensten</title>
            </Head>
            <Layout>
                <Breadcrumb title="Diensten" url="/Diensten"/>
                <Waarom/>
                <Section>
                    <Title
                        id="diensten-aanbod"
                        title="Op welke manier staan we onze partners en klanten bij?"
                    />
                    <div className="container">
                        <div className="row">
                            <DienstCard
                                cols='col-lg-6 col-md-6 col-sm-12'
                                cardId="projectsourcing"
                                faIcon={faPuzzlePiece}
                                bgColor="bg-1"
                                bgIcon="bg-sourcing"
                                title="Projectsourcing"
                                subtitle="Wij stellen onze teamleden ter beschikking voor tijdelijke projecten bij onze klanten. Onze teamleden hebben de expertise om complexe projecten uit te voeren en bieden ondersteuning op locatie. Wij zorgen ervoor dat onze engineers vlot geïntegreerd worden in het team van onze klanten en dat zij de benodigde tools en ondersteuning krijgen om hun werk optimaal te kunnen uitvoeren. Wij bieden onze klanten hoogwaardige engineeringsdiensten aan, zonder dat zij zelf de verantwoordelijkheid hebben voor het werven, opleiden en managen van ze. Hierdoor kunnen zij zich focussen op hun kernactiviteiten en zich verzekeren van een succesvol projectverloop."
                            />
                            <DienstCard
                                cols='col-lg-6 col-md-6 col-sm-12'
                                cardId="recruitment"
                                faIcon={faMagnifyingGlass}
                                bgColor="bg-2"
                                bgIcon="bg-recruitment"
                                title="Recruitment"
                                subtitle="Wij ondersteunen onze klanten bij het vinden van geschikte en zeer specifieke technische werkkrachten voor hun projecten en vacatures. Ons recruitmentproces is gericht op het vinden van de best passende kandidaten, met de juiste technische expertise en persoonlijkheidskenmerken. Wij streven naar een langdurige samenwerking tussen onze klanten en de door ons gerekruteerde profielen. Door gebruik te maken van onze recruitmentdiensten, kunnen onze klanten vertrouwen op ons uitgebreide netwerk en expertise op het gebied van engineering."
                            />

                            <DienstCard
                                cols='col-lg-6 col-md-6 col-sm-12'
                                cardId="begeleiding"
                                faIcon={faChalkboardUser}
                                bgColor="bg-2"
                                bgIcon="bg-begeleiding"
                                title="Begeleiding"
                                subtitle="Wij bieden begeleiding aan om onze klanten te ondersteunen bij technische uitdagingen en projecten. Onze begeleiding is gericht op het bieden van praktische en effectieve oplossingen voor technische vraagstukken. Onze begeleiding kan variëren van technisch advies tot projectmanagement en implementatieondersteuning. Onze experts hebben uitgebreide ervaring in de engineering sector en hebben een brede kennis van technische processen en systemen."
                            />
                            <DienstCard
                                cols='col-lg-6 col-md-6 col-sm-12'
                                cardId="training"
                                faIcon={faCompass}
                                bgColor="bg-1"
                                bgIcon="bg-training"
                                title="Training"
                                subtitle="Wij bieden trainingen aan om de technische expertise van onze klanten te verbeteren. Onze trainingen zijn ontworpen om technische profielen te helpen hun vaardigheden aan te scherpen en hun kennis uit te breiden. Onze trainers hebben uitgebreide ervaring in de engineering sector en bieden praktijkgerichte trainingen die direct toepasbaar zijn in de dagelijkse werkzaamheden. Wij bieden zowel standaard trainingen als maatwerktrainingen die specifiek zijn afgestemd op de behoeften van onze klanten. De domeinen waarin we trainingen geven zijn: ISO 9001, IATF16949, Automotive Core Tools (APQP, PPAP, FMEA, MSA, SPC,…), GMP,…"
                            />
                        </div>
                    </div>
                </Section>
                <Sectors/>
            </Layout>
        </>
    );
};

export default PageDiensten;
